<h2 mat-dialog-title>
  <mat-icon svgIcon="settings"></mat-icon>
  Rediger standardværdier for lokationen
</h2>
<button class="btn-close btn-icon" mat-dialog-close title="Luk dialog">
  <mat-icon class="material-icons">close</mat-icon>
</button>

<mat-dialog-content>
  <adm-loading-spinner [loadingSignal]="loading()"></adm-loading-spinner>
  @if (loading() === false) {
    <form [formGroup]="chargingStationLocationDefaultsFormGroup">
      @if (!canHaveDynamicPricePolicy) {
        <div class="form-row">
          <ok-feedback-info role="status">{{ dynamicPricePolicyWarning }}</ok-feedback-info>
        </div>
      }
      <div class="form-row">
        <adm-adm-price-policy-typeahead
          label="Standard prispolitik"
          [initialPricePolicyId]="initialPricePolicyId?.toString() ?? null"
          [organizationId]="data.organizationId"
          [includeGlobal]="true"
          [alwaysIncludeDynamic]="canHaveDynamicPricePolicy"
          [type]="pricePolicyType"
          (itemSelected)="onPricePolicySelected($event)" />
      </div>
      <div class="form-row">
        <mat-form-field class="mdc-textarea-fix">
          <mat-label>Standard adgangsgrupper</mat-label>
          <mat-select [formControl]="selectedDefaultAccessGroups" multiple [compareWith]="compareObjects" okCustomDropDownArrowDirective>
            <mat-select-trigger>
              {{ selectedDefaultAccessGroups.value[0]?.name || '' }}
              @if (selectedDefaultAccessGroups.value.length > 1) {
                <span class="example-additional-selection">
                  (+{{ selectedDefaultAccessGroups.value.length - 1 }}
                  {{ selectedDefaultAccessGroups.value.length === 2 ? 'mere' : 'flere' }})
                </span>
              }
            </mat-select-trigger>
            @for (accessGroup of accessGroups; track accessGroup) {
              <mat-option [value]="accessGroup">{{ accessGroup.name }}</mat-option>
            }
          </mat-select>
          <mat-icon matSuffix></mat-icon>
        </mat-form-field>
      </div>
    </form>
  }
</mat-dialog-content>

<mat-dialog-actions>
  @if (chargingStationLocation && chargingStationLocation.chargingStationLocationRelationId) {
    <div class="unit-identifier">
      <span>Lokation:</span>
      {{ chargingStationLocation.chargingStationLocationName }}
    </div>
  }

  <button class="actions__button margin--right-2" mat-dialog-close type="button" mat-button>Annuller</button>

  <button
    class="actions__button"
    type="button"
    mat-flat-button
    color="primary"
    [disabled]="chargingStationLocationDefaultsFormGroup.invalid || saving"
    [class.spinner]="saving"
    (click)="saveAndClose()">
    Gem
  </button>
</mat-dialog-actions>
